module.exports = __webpack_public_path__ + "img/box.26dacf95.svg";